// Copyright (c) Move Closer 2022.

/**
 * Base `<InciSection>` configuration - toggle button
 *
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */

export const baseToggleConfig = {
  desktopChars: 320,
  mobileChars: 110
}
